export default "__VITE_ASSET__GmeYbUP2__"